<ng-container *ngIf="!datosRecibidos && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage === '' && datosRecibidos">
    <div class="table-header">
        <div class="header-content">
            <span>LISTADO DE USUARIOS</span>
            <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                <mat-icon>more_vert</mat-icon>
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="descargarExcel()">
                <mat-icon>download</mat-icon>
                <span>Exportar a Excel</span>
            </button>
        </mat-menu>
    </div>

    <div class="mat-elevation-z8">
        <div class="top-container">
            <mat-form-field>
                <mat-label>Filtrar</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex.nombre" #input>
            </mat-form-field>
        </div>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc">

            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Login </th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>

            <ng-container matColumnDef="user_fullname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                <td mat-cell *matCellDef="let element"> {{element.user_fullname}} </td>
            </ng-container>

            <ng-container matColumnDef="cliente">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Cliente </th>
                <td mat-cell *matCellDef="let element"> {{element.cliente}} </td>
            </ng-container>

            <ng-container matColumnDef="pro_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo de Usuario </th>
                <td mat-cell *matCellDef="let element"> {{element.pro_id}} </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha de Alta </th>
                <td mat-cell *matCellDef="let element"> {{formatDateTime(element.created_at)}} </td>
            </ng-container>

            <ng-container matColumnDef="updated_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Modificado </th>
                <td mat-cell *matCellDef="let element"> {{formatDateTime(element.updated_at)}} </td>
            </ng-container>

            <ng-container matColumnDef="user_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.user_status === 0; else tickIcon">
                        <mat-icon class="rojo">cancel</mat-icon>
                    </ng-container>
                    <ng-template #tickIcon>
                        <mat-icon class="verde">check_circle</mat-icon>
                    </ng-template>
                </td>
            </ng-container>

            <ng-container matColumnDef="operaciones">
                <th mat-header-cell *matHeaderCellDef> Operaciones </th>
                <td mat-cell *matCellDef="let element">
                    <div class="button-container">
                        <button mat-mini-fab class="edit-btn" [ngClass]="{ 'transparente': ocultarBoton(element) }"
                            matTooltip="Editar Usuario" aria-label="Editar usuario"
                            routerLink="{{ element.id }}/editar">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[20,40,80]" showFirstLastButtons aria-label="Elige una página"
            class="custom1">
        </mat-paginator>

        <!-- DATOS PAGINADOS -->
        <!-- <mat-paginator 
            [pageSizeOptions]="sizeOptions"
            (page)="pageChanged($event)"
            [pageSize]="currentPageSize"
            [length]="totalItems" 
            aria-label="Elige una página"
            class="custom1">
        </mat-paginator> -->
    </div>
</ng-container>